module.exports = __webpack_public_path__ + "img/more-offers.5da64f20.png";